import { cva } from "class-variance-authority"

export const cardVariants = cva(
  "rounded-2xl border bg-card text-card-foreground shadow-md p-3",
  {
    variants: {
      hoverable: {
        false: null,
        true: "transition-shadow hover:shadow-lg cursor-pointer",
      },
      accent: {
        red: "border-t-8 border-t-red-500",
        blue: "border-t-8 border-t-blue-500",
        green: "border-t-8 border-t-green-500",
        purple: "border-t-8 border-t-purple-500",
        orange: "border-t-8 border-t-orange-500",
        yellow: "border-t-8 border-t-yellow-500",
        primary: "border-t-8 border-t-primary",
      },
    },
    defaultVariants: {
      hoverable: false,
    },
  },
)
